import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../services/api';
import Modal from '../common/Modal';

/**
 * Validation ou refus d'une demande par le distributeur connecté.
 * La validation appose sa signature et son cachet sur la décharge côté serveur.
 */
const DistributeurValidationModal = ({ requestId, mode = 'validate', onClose, onSuccess }) => {
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isReject = mode === 'reject';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isReject && !comment.trim()) {
      setError('Le motif de refus est requis');
      return;
    }

    setLoading(true);
    setError('');
    try {
      if (isReject) {
        await api.distributeur.reject(requestId, { rejectionReason: comment });
        toast.success('Demande refusée');
      } else {
        await api.distributeur.validate(requestId, { comment });
        toast.success('Décharge signée et demande validée');
      }
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      const msg = err.response?.data?.error || 'Erreur lors de l\'opération';
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open
      onClose={onClose}
      title={isReject ? 'Refuser la demande' : 'Signer la décharge'}
      size="md"
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="modal-btn-secondary"
          >
            Annuler
          </button>
          <button
            type="submit"
            form="distributeur-validation-form"
            disabled={loading}
            className={isReject ? 'modal-btn-danger' : 'modal-btn-success'}
          >
            {loading ? 'En cours...' : isReject ? 'Refuser' : 'Signer et valider'}
          </button>
        </>
      }
    >
      <form id="distributeur-validation-form" onSubmit={handleSubmit}>
        <p className="text-sm text-gray-500">
          {isReject
            ? 'Indiquez le motif du refus. La demande sera renvoyée en traitement.'
            : 'En validant, votre signature et votre cachet seront apposés sur la décharge, puis la demande passera à la revue marketing.'}
        </p>

        {error && (
          <div className="mt-4 p-2 bg-red-100 text-red-700 rounded-md text-sm">{error}</div>
        )}

        <div className="mt-4">
          <label htmlFor="distributeur-comment" className="block text-sm font-medium text-gray-700">
            {isReject ? 'Motif du refus' : 'Commentaire (optionnel)'}
            {isReject && <span className="text-red-500"> *</span>}
          </label>
          <textarea
            id="distributeur-comment"
            rows="3"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            disabled={loading}
            required={isReject}
            className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
          />
        </div>
      </form>
    </Modal>
  );
};

export default DistributeurValidationModal;
